var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      ref: "select",
      staticClass: "cargo-project-name-select",
      attrs: {
        value: _vm.value,
        disabled: _vm.disabled,
        placeholder: _vm.placeholder || undefined,
        filterable: "",
        multiple: "",
        clearable: ""
      },
      on: { input: _vm.onInput }
    },
    _vm._l(_vm.options, function(item, index) {
      return _c("el-option", { key: index, attrs: { value: item } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }